import { FCNC } from '../FCNC';
import { useBrandVersion } from '../../hooks';
import { NewLogoWhite } from './NewLogoWhite';
import { TransceptaLogoWhite } from './TransceptaLogoWhite';

/** TODO: use updated/colored assets for new brand (e.g. true white mark vs filter) once final. */
export const BrandLogoWhite: FCNC = () => {
    const brandVersion = useBrandVersion();

    if (brandVersion === 'newBrand') {
        return <NewLogoWhite />;
    }

    return <TransceptaLogoWhite />;
};
